import router from './router';
import store from './store';
import { Toast } from 'vant';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { getToken } from '@/utils/auth';
import { isRelogin } from '@/utils/request';

NProgress.configure({ showSpinner: false });

const whiteList = ['/login', '/entrance', '/register', '/forgotPassword'];

router.beforeEach((to, from, next) => {
  NProgress.start();
  // 抽奖页面不管登录与不登陆都允许进入
  if(to.path === "/game") {
    next();
    NProgress.done();
    return;
  }
  if (getToken()) {
    /* has token*/
    if (whiteList.indexOf(to.path) !== -1) {
      next({ path: '/' });
      NProgress.done();
    } else {
      if (!store.getters.userInfo) {
        isRelogin.show = true;
        // 判断当前用户是否已拉取完user_info信息
        store
          .dispatch('GetInfo')
          .then(() => {
            isRelogin.show = false;
            next({ ...to, replace: true });
          })
          .catch((err) => {
            store.dispatch('LogOut').then(() => {
              Toast(err);
              next({ path: '/entrance' });
            });
          });
      } else {
        const userIsRealName = store.state.login.userInfo.realcheck;
        // console.log(userIsRealName,'12312312')

        if (userIsRealName != 3 ) {
          // 如果用户已实名，继续导航到目标路由
          Toast('请实名认证后继续操作');
        }
        // 如果用户未实名，执行你的弹出框或其他操作
        // 这里你可以使用 Toast 等方式显示提示信息

        next();
      }
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next();
    } else {
      next(`/entrance`); // 否则全部重定向到登录页
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});
